export default "__VITE_ASSET__o9I$DG5U__"